import script from "./PmIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PmIcon.vue?vue&type=script&setup=true&lang=js"

import "./PmIcon.vue?vue&type=style&index=0&id=c0ac4a34&lang=scss&scoped=true"

import exportComponent from "../../preview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ac4a34"]])

export default __exports__